import { render, staticRenderFns } from "./hqglLogisticsDisposeInfo.vue?vue&type=template&id=35eef3c8&scoped=true&"
import script from "./hqglLogisticsDisposeInfo.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsDisposeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eef3c8",
  null
  
)

export default component.exports